<template>
    <div class="d-block">
        <page-banner v-bind:data="bannerData" v-if="bannerData"/>
        <div class="list-container">
            <div class="public-tabs-nav">
                <a class="tabs-nav" :class="{active: tabsActive === index}" v-for="(item, index) in language === 'zh-cn' ? tabsNav.cn : tabsNav.en" :key="index" @click="onPublicTabs(item, index)">
                    <span class="d-block" style="padding: 0 48px;">{{ item }}</span>
                </a>
            </div>
            <span class="d-block" style="height: 80px;">&nbsp;</span>
            <div class="public-tabs-content">
                <div class="d-block" v-if="tabsActive === 0">
                    <div class="container">
                        <div class="d-block" data-box="article-content" v-html="companyProfile"></div>
                    </div>
                </div>
                <div class="d-block" v-if="tabsActive === 1">
                    <div class="container">
                        <div class="d-block" data-box="article-content" v-html="brandStory"></div>
                    </div>
                </div>
                <div class="d-block" v-if="tabsActive === 2">
                    <div class="container">
                        <div class="d-block" data-box="quality-box">
                            <div class="d-flex justify-center height-all bg-black" v-for="(item, index) in honorArray" :key="index">
                                <img alt="" :preview="0" :src="item.image" style="max-width: 100%; max-height: 100%;"/>
                                <h3 class="quality-title">{{ item.name }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-block" v-if="tabsActive === 3">
                    <div class="d-flex" style="margin: 0 -144px;">
                        <div class="d-flex-item">
                            <baidu-map ref="mapContainer" :center="mapCompanyCenter" :zoom="mapZoom" :auto-resize="false" :scroll-wheel-zoom="true" @ready="readyCompanyMaps" style="width: 100%; height: 520px;">
                                <!-- 标记点 -->
                                <bm-marker :position="{lng: mapCompanyMarker.lng, lat: mapCompanyMarker.lat}" :icon="{url: mapCompanyMarker.icon, size: {width: 44, height: 44} }" :dragging="false"/>
                                <!-- 信息窗体 -->
                                <bm-info-window :show="true" :position="{ lng: mapCompanyMarker.lng, lat: mapCompanyMarker.lat}" :width="360" :closeOnClick="false">
                                    <div class="d-block">
                                        <div class="d-block pb-sm">
                                            <h2>{{ mapCompanyMarker.name }}</h2>
                                            <hr/>
                                            <h3>{{ language === 'zh-cn' ? '地址' : 'Address' }}：{{ mapCompanyMarker.address }}</h3>
                                        </div>
                                    </div>
                                </bm-info-window>
                            </baidu-map>
                        </div>
                        <span class="bg-gray" v-if="false">&nbsp;</span>
                        <div class="d-flex-item" v-if="false">
                            <baidu-map ref="mapContainer" :center="mapShowroomMarker" :zoom="mapZoom" :auto-resize="false" :scroll-wheel-zoom="true" @ready="readyShowroomMaps" style="width: 100%; height: 520px;">
                                <!-- 标记点 -->
                                <bm-marker :position="{lng: mapShowroomMarker.lng, lat: mapShowroomMarker.lat}" :icon="{url: mapShowroomMarker.icon, size: {width: 44, height: 44} }" :dragging="false"/>
                                <!-- 信息窗体 -->
                                <bm-info-window :show="true" :position="{ lng: mapShowroomMarker.lng, lat: mapShowroomMarker.lat}" :width="320" :closeOnClick="false">
                                    <div class="d-block">
                                        <div class="d-block pb-sm">
                                            <div class="d-block pb-sm">
                                                <h2>{{ mapShowroomMarker.name }}</h2>
                                                <hr/>
                                                <h3>地址：{{ mapShowroomMarker.address }}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </bm-info-window>
                            </baidu-map>
                        </div>
                    </div>
                    <span class="d-block" style="height: 80px;">&nbsp;</span>
                    <online-consultative v-bind:lang="language" v-bind:useType="'pages'"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .list-container{
        padding: 0 80px 80px 80px;
    }
    [data-box="quality-box"]{
        display: flex;
        display: -webkit-flex;
        box-sizing: content-box;
        width: 100%;
        position: relative;
        flex-wrap: wrap;
        margin: 0 -16px;
    }
    [data-box="quality-box"] > div{
        flex: 1;
        width: 30.125%;
        min-width: 30.125%;
        max-width: 30.125%;
        margin: 16px;
        height: 375px;
    }
    [data-box="quality-box"] .quality-title{
        position: absolute;
        box-sizing: content-box;
        width: calc(100% - 32px);
        padding: 16px;
        left: 0;
        bottom: 0;
        text-align: center;
        color: #fff;
        background:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .75) 100%);
    }
</style>

<style type="text/css">
    .anchorBL{ display: none; }
</style>

<script type="text/javascript">
    import PageBanner from "../../components/PageBanner";
    import OnlineConsultative from "../../components/OnlineConsultative";

    export default {
        components: {
            PageBanner, OnlineConsultative
        },
        data () {
            return {
                language: 'zh-cn',
                bannerData: null,
                tabsNav: {
                    cn: ['公司简介', '品牌故事', '荣誉资质', '联系我们'],
                    en: ['Company Profile', 'Brand story', 'Honor', 'Contact Us'],
                },
                tabsActive: 0,
                companyProfile: null,
                brandStory: null,
                honorArray: [],
                total: 0,
                current: 1,
                pageSize: 10,

                mapZoom: 13, // 缩放等级
                mapCompanyCenter: {},
                mapCompanyMarker: {
                    id: 1,
                    lng: 116.322533,
                    lat: 40.04809,
                    icon: 'static/icon/icon-map-marker-error@44px.png',
                    name: '',
                    address: '',
                },
                mapShowroomCenter: {},
                mapShowroomMarker: {
                    id: 1,
                    lng: 116.214041,
                    lat: 40.112873,
                    icon: 'static/icon/icon-map-marker-error@44px.png',
                    name: '源音文创展示中心',
                    address: '北京市海淀区上庄镇上庄村临368号',
                },
            }
        },
        created() {
            console.log('当前语言----->' + this.$store.state.language);
            this.language = this.$store.state.language;
            if (this.language === 'zh-cn'){
                this.mapCompanyMarker.name = '北京源音文创科技股份有限公司';
                this.mapCompanyMarker.address = '北京市海淀区安宁庄西路9号院25号楼7层3-726A （地铁13号线清河地铁站东广场出口）';
            } else {
                this.mapCompanyMarker.name = 'Beijing Anystage Cultural Creative Technology Co.,Ltd';
                this.mapCompanyMarker.address = 'Room 3-726A, Building 25, No.9 Yard, An Ningzhuang West Road, HaiDian District, Beijing, China （East Plaza Exit at Qing He Station of Subway Line 13,）';
            }
        },
        mounted() {
            this.__getBanner();
            this.__getCompanyProfile();
            this.__getBrandStory();
            this.__getHonor();
        },
        methods: {
            onPublicTabs(data, i){
                console.log(data, i);
                this.tabsActive = i;
            },
            __getBanner(){
                this.$api.getHttp('banner?bannerType=ABOUT', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.bannerData = res.data.data;
                        // console.log(this.bannerData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getCompanyProfile(){
                this.$api.getHttp('about-us?type=COMPANY_PROFILE', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.companyProfile = res.data.data.content;
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getBrandStory(){
                this.$api.getHttp('about-us?type=BRAND_STORY', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.brandStory = res.data.data.content;
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getHonor(){
                this.$api.getHttp('honor', {
                    language: this.language,
                }).then((res) => {
                    console.log('<---------- res ---------->');
                    console.log(res);
                    if (res.status === 200){
                        this.honorArray = res.data.data;
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },

            // 初始化地图
            readyCompanyMaps ({ BMap, map }) {
                // map.disableDragging(); //禁止拖动
                // map.disableScrollWheelZoom(); //禁止缩放
                map.disableDoubleClickZoom(); //禁止双击缩放
                this.mapCompanyCenter = {
                    lng: 116.359815,
                    lat: 40.021982,
                };
                this.mapZoom = 13;
                console.log(BMap, map);
            },
            readyShowroomMaps({ BMap, map }){
                // map.disableDragging(); //禁止拖动
                // map.disableScrollWheelZoom(); //禁止缩放
                map.disableDoubleClickZoom(); //禁止双击缩放
                this.mapShowroomCenter = {
                    lng: 116.214041,
                    lat: 40.112873,
                };
                this.mapZoom = 13;
                console.log(BMap, map);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/about/list.vue